/**
 * API genérica de Desbloqueio de Confiança.
 * Suporta parâmetros: cpf, id, qtd_dias (dependendo da integração).
 * Novas integrações podem adicionar outros parâmetros aqui.
 */
import { axiosInstance } from '@/service/axios';

export interface DesbloqueioConfiancaParams {
  cpf?: string;
  id?: number;
  qtd_dias?: number;
}

export async function requestDesbloqueioConfianca(params: DesbloqueioConfiancaParams): Promise<void> {
  await axiosInstance.get('/desbloqueio-confianca', { params });
}
